var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckCircleGrey = function SvgCheckCircleGrey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 15,
    height: 15,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#BEBEBE",
    d: "M7.367 10.14c-.3.3-.765.3-1.066 0L4.55 8.39c-.301-.301-.301-.766 0-1.067.3-.3.765-.3 1.066 0l1.23 1.203 2.954-2.953c.3-.3.765-.3 1.066 0s.301.766 0 1.066zm7.356-2.297c0 3.882-3.145 7-7 7-3.883 0-7-3.118-7-7 0-3.856 3.117-7 7-7 3.855 0 7 3.144 7 7m-7-5.688c-3.145 0-5.688 2.57-5.688 5.688a5.683 5.683 0 0 0 5.688 5.687c3.117 0 5.687-2.543 5.687-5.687 0-3.118-2.57-5.688-5.687-5.688"
  })));
};
export default SvgCheckCircleGrey;